import { type ReactElement, type ReactNode, useMemo, useState } from 'react';

import { PreloadedPanel } from './PreloadedPanel';
import type { PanelComponent, TriggerContext } from './types';

export function usePanel(preloadedPanel?: ReactElement<any, typeof PreloadedPanel>): {
	Panel: PanelComponent;
	trigger: TriggerContext;
} {
	const [panel, setPanel] = useState<ReactNode>(preloadedPanel);

	const Panel = useMemo<PanelComponent>(() => {
		const PanelComponent = () => panel ?? null;
		return PanelComponent;
	}, [panel]);

	const trigger = useMemo<TriggerContext>(
		() => ({
			setPanel: (panel: ReactNode) => setPanel(panel),
		}),
		[setPanel],
	);

	return useMemo(() => ({ Panel, trigger }), [Panel, trigger]);
}
